module.exports = __webpack_public_path__ + "3aa9ef95cc4630428b294d8b53e02973.svg";